import { mapValues } from 'lodash';
import { invokeEvent, parseTexturedMaterial } from 'shared-base';
import { References } from '../types';

export const parseTextaco = (data: any, references: References) => {
  const { allMaterials, textResolution } = references;

  try {
    const { materials = [] } = data as any;
    const pack = materials[0];

    if (!pack) {
      return;
    }

    return mapValues(pack, (material: IMaterial) => {
      const { id, metalness, roughness, tint = '' } = material;

      const originalMat = parseTexturedMaterial(allMaterials[id] ?? {}, textResolution);

      return {
        ...originalMat,
        roughness,
        metalness,
        tint: tint.replace(/ff$/, ''), // #ffffff
      };
    });
  } catch (err) {
    invokeEvent('sentry', { err });
  }
};
